import defaultActions from './defaultReduxActions';

const actions = defaultActions({ namespace: 'contact-form' });

export const { find, create, get, patch, reducer, remove } = actions;

export default reducer;
